// extracted by mini-css-extract-plugin
module.exports = {"braintreeWrapper":"styles_braintreeWrapper__2DGrY"};